<template>
  <div class="business">
    <a-skeleton :loading="loading">
      <a-card title="登记信息" :bordered="false" id="card1">
        <CheckInfo :data="registerInfo" />
      </a-card>
      <a-card title="股东信息" :bordered="false" id="card2">
        <ShareHolderInfo :data="shareholderInfo" />
      </a-card>
      <a-card title="主要人员" :bordered="false" id="card3">
        <div class="y-scroll-400">
          <MainMember :data="keyPersonnel" />
        </div>
      </a-card>
      <a-card title="分支机构" :bordered="false" id="card4">
        <div class="y-scroll-400">
          <BranchOrganization :data="branchInfo" />
        </div>
      </a-card>
      <a-card title="变更记录" :bordered="false" id="card5">
        <div class="y-scroll-400">
          <ChangeList :data="changeRegistration" />
        </div>
      </a-card>
      <a-card title="对外投资" :bordered="false" id="card6">
        <div class="y-scroll-400">
          <AbroadInvest :data="enterpriseForeignInvestment" />
        </div>
      </a-card>
      <a-card title="法人代表对外投资" :bordered="false" id="card7">
        <div class="y-scroll-400">
          <CeoAbroadInvest :data="legalRepresentativeForeignInvestment" />
        </div>
      </a-card>
      <a-card title="法人代表对外任职" :bordered="false" id="card8">
        <div class="y-scroll-400">
          <CeoAbroadPosition :data="legalRepresentativeForeignTenure" />
        </div>
      </a-card>
      <a-card title="股权出质" :bordered="false" id="card9">
        <div class="y-scroll-400">
          <EquityPledged :data="equityPledge" />
        </div>
      </a-card>
      <a-card title="动产抵押" :bordered="false" id="card10">
        <div class="y-scroll-400">
          <ChattelMortgage :data="chattelMortgage" />
        </div>
      </a-card>
      <a-card title="经营异常" :bordered="false" id="card11">
        <div class="y-scroll-400">
          <AbnormalOperation :data="abnormalOperation" />
        </div>
      </a-card>
      <a-card title="行政处罚" :bordered="false" id="card12">
        <div class="y-scroll-400">
          <OfficePunish :data="administrativePenalty" />
        </div>
      </a-card>
      <a-card title="股权冻结" :bordered="false" id="card13">
        <div class="y-scroll-400">
          <EquityFreeze :data="equityFreeze" />
        </div>
      </a-card>
      <a-anchor :target-offset="targetOffset" :affix="true" class="anchor-wrap">
        <a-anchor-link href="#card1" title="登记信息" />
        <a-anchor-link href="#card2" title="股东信息" />
        <a-anchor-link href="#card3" title="主要人员" />
        <a-anchor-link href="#card4" title="分支机构" />
        <a-anchor-link href="#card5" title="变更记录" />
        <a-anchor-link href="#card6" title="对外投资" />
        <a-anchor-link href="#card7" title="法人代表对外投资" />
        <a-anchor-link href="#card8" title="法人代表对外任职" />
        <a-anchor-link href="#card9" title="股权出质" />
        <a-anchor-link href="#card10" title="动产抵押" />
        <!-- <a-anchor-link href="#card4" title="土地抵押" /> 
            <a-anchor-link href="#card4" title="土地交易" />-->
        <a-anchor-link href="#card11" title="经营异常" />
        <!-- <a-anchor-link href="#card4" title="行政许可" /> -->
        <a-anchor-link href="#card12" title="行政处罚" />
        <!-- <a-anchor-link href="#card4" title="欠税信息" />
            <a-anchor-link href="#card4" title="税务非正常户" />
            <a-anchor-link href="#card4" title="重大税收违法" /> -->
        <a-anchor-link href="#card13" title="股权冻结" />
        <!-- <a-anchor-link href="#card4" title="招投标" />
            <a-anchor-link href="#card4" title="社保信息" /> -->
      </a-anchor>
    </a-skeleton>
  </div>
</template>
<script>
import { getCheckInfoList } from './components/business-api'
import CheckInfo from './components/CheckInfo.vue'
import ShareHolderInfo from './components/ShareHolderInfo.vue'
import MainMember from './components/MainMember.vue'
import BranchOrganization from './components/BranchOrganization.vue'
import AbroadInvest from './components/AbroadInvest.vue'
import CeoAbroadInvest from './components/CeoAbroadInvest.vue'
import CeoAbroadPosition from './components/CeoAbroadPosition.vue'
import EquityPledged from './components/EquityPledged.vue'
import ChattelMortgage from './components/ChattelMortgage.vue'
import AbnormalOperation from './components/AbnormalOperation.vue'
import OfficePunish from './components/OfficePunish.vue'
import ChangeList from './components/ChangeList.vue'
import EquityFreeze from './components/EquityFreeze.vue'
export default {
  components: {
    CheckInfo,
    ShareHolderInfo,
    MainMember,
    BranchOrganization,
    ChangeList,
    AbroadInvest,
    CeoAbroadInvest,
    CeoAbroadPosition,
    EquityPledged,
    ChattelMortgage,
    AbnormalOperation,
    OfficePunish,
    EquityFreeze,
  },
  data() {
    return {
      targetOffset: undefined,
      registerInfo: {}, //登记信息
      shareholderInfo: [], //股东信息
      keyPersonnel: [], //主要人员
      branchInfo: [], //分支机构
      changeRegistration: [], //变更记录
      enterpriseForeignInvestment: [], //对外投资
      legalRepresentativeForeignInvestment: [], //法人代表对外投资
      legalRepresentativeForeignTenure: [], //法人代表对外任职
      equityPledge: [], //股权出质
      chattelMortgage: [], //动产抵押
      abnormalOperation: [], //经营异常
      administrativePenalty: [], //行政处罚
      equityFreeze: [], //股权冻结
      visible: true,
      confirmLoading: false,
      TIP_PAY_MONEY: '此接口收费，确定继续前往吗？',
      pageData: {
        current: 1,
        pageSize: 10,
      },
      loading: true,
    }
  },
  mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      // enterpriseName: '北京联想金服科技有限公司'
    }

    this.getInfo(params)
    this.targetOffset = window.innerHeight / 2
  },
  methods: {
    handleVisible() {
      this.visible = true
    },
    async getInfo(params) {
      const {
        resultCode,
        resultData: {
          registerInfo, //登记信息
          shareholderInfo, //股东信息
          keyPersonnel, //主要人员
          branchInfo, //分支机构
          changeRegistration, //变更记录
          enterpriseForeignInvestment, //对外投资
          legalRepresentativeForeignInvestment, //法人代表对外投资
          legalRepresentativeForeignTenure, //法人代表对外任职
          equityPledge, //股权出质
          chattelMortgage, //动产抵押
          abnormalOperation, //经营异常
          administrativePenalty, //行政处罚
          equityFreeze, //股权冻结
        },
      } = await getCheckInfoList(params)
      if (resultCode == '0') {
        this.registerInfo = registerInfo
        this.shareholderInfo = shareholderInfo
        this.keyPersonnel = keyPersonnel
        this.branchInfo = branchInfo
        this.changeRegistration = changeRegistration
        this.enterpriseForeignInvestment = enterpriseForeignInvestment
        this.legalRepresentativeForeignInvestment = legalRepresentativeForeignInvestment
        this.legalRepresentativeForeignTenure = legalRepresentativeForeignTenure
        this.equityPledge = equityPledge
        this.chattelMortgage = chattelMortgage
        this.abnormalOperation = abnormalOperation
        this.administrativePenalty = administrativePenalty
        this.equityFreeze = equityFreeze
        this.loading = false
      }
    },
    handleOk() {
      this.loading = false
      this.visible = false
      this.getInfo()
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">
.business {
  /deep/ .anchor-wrap {
    position: fixed;
    right: 30px;
    top: 250px;
    z-index: 2;
  }
}
</style>
<style scoped>
.y-scroll-400 {
  height: 400px;
  overflow-y: scroll;
}
</style>
